import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

import letterhead from "./zuluwhiskeylettterhead.png";

// ==============================
// STYLES
// ==============================
const styles = StyleSheet.create({
  page: {
    paddingTop: 18,
    paddingBottom: 55,
    paddingHorizontal: 24,
    fontSize: 9.2,
    fontFamily: "Helvetica",
    color: "#111827",
    lineHeight: 1.55,
  },

  letterhead: {
    width: "112%",
    height: 105,
    marginLeft: -24,
    marginRight: -24,
    marginTop: -18,
    marginBottom: 0,
    objectFit: "cover",
  },

  headerLine: {
    height: 5,
    backgroundColor: "#000000",
    width: "112%",
    marginLeft: -24,
    marginTop: 0,
    marginBottom: 12,
  },

  agreementTitleWrap: {
    alignItems: "center",
    marginBottom: 12,
  },

  agreementTitle: {
    fontSize: 11,
    fontWeight: "bold",
    letterSpacing: 1,
  },

  agreementDate: {
    fontSize: 8.4,
    color: "#6B7280",
    marginTop: 2,
  },

  introText: {
    marginBottom: 10,
    textAlign: "justify",
    fontSize: 9,
    lineHeight: 1.6,
  },

  sectionTitle: {
    fontSize: 10,
    fontWeight: "bold",
    backgroundColor: "#F3F4F6",
    paddingVertical: 5,
    paddingHorizontal: 7,
    marginTop: 10,
    marginBottom: 6,
    borderLeft: "3 solid #111827",
    borderTop: "1 solid #D1D5DB",
    borderBottom: "1 solid #D1D5DB",
  },

  twoColumn: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 10,
    marginBottom: 10,
  },

  infoCard: {
    width: "48%",
    border: "1 solid #E5E7EB",
    padding: 8,
  },

  infoText: {
    marginBottom: 4,
    fontSize: 8.8,
  },

  vehicleBox: {
    border: "1 solid #E5E7EB",
    padding: 8,
    marginBottom: 8,
  },

  vehicleRow: {
    flexDirection: "row",
    marginBottom: 4,
  },

  vehicleLabel: {
    width: "28%",
    color: "#6B7280",
    fontWeight: "bold",
  },

  vehicleValue: {
    width: "72%",
  },

  paragraph: {
    marginBottom: 7,
    textAlign: "justify",
    fontSize: 8.9,
    lineHeight: 1.6,
  },
signatureSection: {
  marginTop: 24,
  borderTop: "1 solid #D1D5DB",
  paddingTop: 12,
},

signatureRow: {
  flexDirection: "row",
  justifyContent: "space-between",
  marginTop: 24,
},

signatureCol: {
  width: "45%",
  alignItems: "center",
},

signatureLine: {
  width: 180,
  borderTop: "1 solid #111827",
  paddingTop: 6,
  textAlign: "center",
  fontSize: 9,
},

signLabel: {
  marginTop: 4,
  fontSize: 8.5,
  color: "#6B7280",
  textAlign: "center",
},
  signLabel: {
    marginTop: 4,
    fontSize: 8.5,
    color: "#6B7280",
    textAlign: "center",
  },

  footer: {
    position: "absolute",
    bottom: 16,
    left: 24,
    right: 24,
    borderTop: "1 solid #E5E7EB",
    paddingTop: 6,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 8,
    color: "#6B7280",
  },
});

// ==============================
// COMPONENT
// ==============================
const CarPurchaseAgreementPdf = ({ data }) => {
  if (!data) return null;

  const agreementDate = new Date().toLocaleDateString();

  const frequencyLabel = data.installment_frequency || "monthly";
  const lateFreq = data.late_payment_frequency || "per month";

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* HEADER */}
        <View wrap={false}>
          <Image src={letterhead} style={styles.letterhead} />
          <View style={styles.headerLine} />

          <View style={styles.agreementTitleWrap}>
            <Text style={styles.agreementTitle}>
              CAR PURCHASE AGREEMENT
            </Text>

            <Text style={styles.agreementDate}>
              Agreement Date: {agreementDate}
            </Text>
          </View>
        </View>

        {/* INTRO */}
        <Text style={styles.introText}>
          This Car Purchase Agreement is entered into between the Seller
          and Buyer for the purchase of the motor vehicle described herein.
          Both parties agree to the terms outlined below.
        </Text>

        {/* SELLER / BUYER */}
        <View style={styles.twoColumn}>

          <View style={styles.infoCard}>
            <Text style={styles.sectionTitle}>Seller Information</Text>
            <Text style={styles.infoText}>Name: {data.seller_name}</Text>
            <Text style={styles.infoText}>Email: {data.seller_email}</Text>
            <Text style={styles.infoText}>Phone: {data.seller_phone}</Text>
            <Text style={styles.infoText}>Address: {data.seller_address}</Text>
          </View>

          <View style={styles.infoCard}>
            <Text style={styles.sectionTitle}>Buyer Information</Text>
            <Text style={styles.infoText}>Name: {data.buyer_name}</Text>
            <Text style={styles.infoText}>Email: {data.buyer_email}</Text>
            <Text style={styles.infoText}>Phone: {data.buyer_phone}</Text>
            <Text style={styles.infoText}>Address: {data.buyer_address}</Text>
          </View>

        </View>

        {/* VEHICLE */}
        <Text style={styles.sectionTitle}>Vehicle Description</Text>

        <View style={styles.vehicleBox}>
          <View style={styles.vehicleRow}>
            <Text style={styles.vehicleLabel}>Make:</Text>
            <Text style={styles.vehicleValue}>{data.make}</Text>
          </View>

          <View style={styles.vehicleRow}>
            <Text style={styles.vehicleLabel}>Model:</Text>
            <Text style={styles.vehicleValue}>{data.model}</Text>
          </View>

          <View style={styles.vehicleRow}>
            <Text style={styles.vehicleLabel}>Year:</Text>
            <Text style={styles.vehicleValue}>{data.year}</Text>
          </View>

          <View style={styles.vehicleRow}>
            <Text style={styles.vehicleLabel}>VIN:</Text>
            <Text style={styles.vehicleValue}>{data.vin}</Text>
          </View>

          <View style={styles.vehicleRow}>
            <Text style={styles.vehicleLabel}>Mileage:</Text>
            <Text style={styles.vehicleValue}>{data.mileage}</Text>
          </View>
        </View>

        {/* PAYMENT TERMS */}
        <Text style={styles.sectionTitle}>
          Purchase Price and Payment Terms
        </Text>

          <Text style={styles.paragraph}>
            The total purchase price is USD ${data.total_price}. The Buyer agrees
            to pay a down payment of USD ${data.down_payment} and a second payment
            of USD ${data.second_payment}. The remaining balance of USD ${data.remaining_balance}
            will be paid in {data.number_of_installments}{" "}
            {frequencyLabel.toLowerCase()} installments of USD ${data.installment_amount}
            each, starting on {data.first_installment_date}.
          </Text>

        {/* LATE PAYMENT */}
        <Text style={styles.sectionTitle}>
          Late Payment / Default
        </Text>

          <Text style={styles.paragraph}>
            If the Buyer fails to make any scheduled payment on time,
            a late fee of USD ${data.late_payment_fee}{" "}
            {lateFreq.toLowerCase()} will be applied to the overdue amount until
            full payment is made.
          </Text>

        <Text style={styles.paragraph}>
          If payment is overdue for more than thirty (30) days, the Seller
          may repossess the vehicle and retain prior payments as damages.
        </Text>

        {/* OWNERSHIP */}
        <Text style={styles.sectionTitle}>Transfer of Ownership</Text>

        <Text style={styles.paragraph}>
          Ownership transfers only after full payment is received.
        </Text>

        {/* CONDITION */}
        <Text style={styles.sectionTitle}>Condition of Vehicle</Text>

        <Text style={styles.paragraph}>
          Buyer accepts vehicle in its current condition with no additional warranties.
        </Text>

        {/* GOVERNING LAW */}
        <Text style={styles.sectionTitle}>Governing Law</Text>

        <Text style={styles.paragraph}>
          This Agreement is governed by the laws of {data.state_law || "__________"}.
        </Text>

        {/* SIGNATURES */}
        <View style={styles.signatureSection}>
  <Text style={styles.sectionTitle}>Signatures</Text>

  <View style={styles.signatureRow}>
    <View style={styles.signatureCol}>
      <View style={styles.signatureLine}>
        <Text>{data.seller_name}</Text>
      </View>
      <Text style={styles.signLabel}>Seller Signature</Text>
    </View>

    <View style={styles.signatureCol}>
      <View style={styles.signatureLine}>
        <Text>{data.buyer_name}</Text>
      </View>
      <Text style={styles.signLabel}>Buyer Signature</Text>
    </View>
  </View>
</View>

        {/* FOOTER */}
        <View style={styles.footer} fixed>
          <Text>ZuluWhiskey ShippingLegal System</Text>
          <Text>Confidential Document</Text>
        </View>

      </Page>
    </Document>
  );
};

export default CarPurchaseAgreementPdf;




// // CarPurchaseAgreementPdf.js

// import React from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";

// import letterhead from "./zuluwhiskeylettterhead.png";

// // ==============================
// // STYLES
// // ==============================
// const styles = StyleSheet.create({
//   // PAGE
//   page: {
//     paddingTop: 18,
//     paddingBottom: 55,
//     paddingHorizontal: 24,

//     fontSize: 9.2,
//     fontFamily: "Helvetica",
//     color: "#111827",
//     lineHeight: 1.55,
//   },

//   // ==============================
//   // LETTERHEAD
//   // ==============================
//   letterhead: {
//     width: "112%",
//     height: 105,

//     marginLeft: -24,
//     marginRight: -24,
//     marginTop: -18,
//     marginBottom: 0,

//     objectFit: "cover",
//   },

//   // BLACK HEADER LINE
//   headerLine: {
//     height: 5,
//     backgroundColor: "#000000",

//     width: "112%",
//     marginLeft: -24,
//     marginTop: 0,
//     marginBottom: 12,
//   },

//   // ==============================
//   // TITLE
//   // ==============================
//   agreementTitleWrap: {
//     alignItems: "center",
//     marginBottom: 12,
//   },

//   agreementTitle: {
//     fontSize: 11,
//     fontWeight: "bold",
//     letterSpacing: 1,
//     color: "#111827",
//   },

//   agreementDate: {
//     fontSize: 8.4,
//     color: "#6B7280",
//     marginTop: 2,
//   },

//   // ==============================
//   // INTRO
//   // ==============================
//   introText: {
//     marginBottom: 10,
//     textAlign: "justify",
//     fontSize: 9,
//     lineHeight: 1.6,
//   },

//   // ==============================
//   // SECTION TITLES
//   // ==============================
//   sectionTitle: {
//     fontSize: 10,
//     fontWeight: "bold",

//     backgroundColor: "#F3F4F6",

//     paddingVertical: 5,
//     paddingHorizontal: 7,

//     marginTop: 10,
//     marginBottom: 6,

//     borderLeft: "3 solid #111827",
//     borderTop: "1 solid #D1D5DB",
//     borderBottom: "1 solid #D1D5DB",
//   },

//   // ==============================
//   // TWO COLUMN
//   // ==============================
//   twoColumn: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     gap: 10,
//     marginBottom: 10,
//   },

//   infoCard: {
//     width: "48%",
//     border: "1 solid #E5E7EB",
//     padding: 8,
//     borderRadius: 3,
//   },

//   infoText: {
//     marginBottom: 4,
//     fontSize: 8.8,
//     lineHeight: 1.45,
//   },

//   // ==============================
//   // VEHICLE
//   // ==============================
//   vehicleBox: {
//     border: "1 solid #E5E7EB",
//     padding: 8,
//     marginBottom: 8,
//   },

//   vehicleRow: {
//     flexDirection: "row",
//     marginBottom: 4,
//   },

//   vehicleLabel: {
//     width: "28%",
//     color: "#6B7280",
//     fontWeight: "bold",
//   },

//   vehicleValue: {
//     width: "72%",
//   },

//   // ==============================
//   // PARAGRAPH
//   // ==============================
//   paragraph: {
//     marginBottom: 7,
//     textAlign: "justify",
//     fontSize: 8.9,
//     lineHeight: 1.6,
//   },

//   // ==============================
//   // SIGNATURES
//   // ==============================
//   signatureSection: {
//     marginTop: 24,
//     borderTop: "1 solid #D1D5DB",
//     paddingTop: 12,
//   },

//   signatureRow: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     gap: 30,
//     marginTop: 24,
//   },

//   signatureCol: {
//     flex: 1,
//   },

//   signatureLine: {
//     borderTop: "1 solid #111827",
//     paddingTop: 6,
//     fontSize: 9,
//     textAlign: "center",
//   },

//   signLabel: {
//     marginTop: 4,
//     fontSize: 8.5,
//     color: "#6B7280",
//     textAlign: "center",
//   },

//   dateText: {
//     marginTop: 18,
//     fontSize: 9,
//   },

//   // ==============================
//   // FOOTER
//   // ==============================
//   footer: {
//     position: "absolute",
//     bottom: 16,
//     left: 24,
//     right: 24,

//     borderTop: "1 solid #E5E7EB",
//     paddingTop: 6,

//     flexDirection: "row",
//     justifyContent: "space-between",

//     fontSize: 8,
//     color: "#6B7280",
//   },
// });

// // ==============================
// // COMPONENT
// // ==============================
// const CarPurchaseAgreementPdf = ({ data }) => {
//   if (!data) return null;

//   const agreementDate = new Date().toLocaleDateString();

//   return (
//     <Document>
//       <Page
//         size="A4"
//         style={styles.page}
//         wrap
//       >

//         {/* ==============================
//             FIRST PAGE HEADER ONLY
//         ============================== */}
//         <View wrap={false}>

//           {/* LETTERHEAD */}
//           <Image
//             src={letterhead}
//             style={styles.letterhead}
//           />

//           {/* BLACK LINE */}
//           <View style={styles.headerLine} />

//           {/* TITLE */}
//           <View style={styles.agreementTitleWrap}>
//             <Text style={styles.agreementTitle}>
//               CAR PURCHASE AGREEMENT
//             </Text>

//             <Text style={styles.agreementDate}>
//               Agreement Date: {agreementDate}
//             </Text>
//           </View>

//         </View>

//         {/* ==============================
//             INTRO
//         ============================== */}
//         <Text style={styles.introText}>
//           This Car Purchase Agreement is entered into between the
//           Seller and Buyer for the purchase of the motor vehicle
//           described herein. Both parties acknowledge and agree
//           that the following terms constitute a legally binding
//           agreement.
//         </Text>

//         {/* ==============================
//             SELLER / BUYER
//         ============================== */}
//         <View style={styles.twoColumn}>

//           {/* SELLER */}
//           <View style={styles.infoCard}>
//             <Text style={styles.sectionTitle}>
//               Seller Information
//             </Text>

//             <Text style={styles.infoText}>
//               Name: {data.seller_name}
//             </Text>

//             <Text style={styles.infoText}>
//               Email: {data.seller_email}
//             </Text>

//             <Text style={styles.infoText}>
//               Phone: {data.seller_phone}
//             </Text>

//             <Text style={styles.infoText}>
//               Address: {data.seller_address}
//             </Text>
//           </View>

//           {/* BUYER */}
//           <View style={styles.infoCard}>
//             <Text style={styles.sectionTitle}>
//               Buyer Information
//             </Text>

//             <Text style={styles.infoText}>
//               Name: {data.buyer_name}
//             </Text>

//             <Text style={styles.infoText}>
//               Email: {data.buyer_email}
//             </Text>

//             <Text style={styles.infoText}>
//               Phone: {data.buyer_phone}
//             </Text>

//             <Text style={styles.infoText}>
//               Address: {data.buyer_address}
//             </Text>
//           </View>

//         </View>

//         {/* ==============================
//             VEHICLE DESCRIPTION
//         ============================== */}
//         <Text style={styles.sectionTitle}>
//           Vehicle Description
//         </Text>

//         <View style={styles.vehicleBox}>

//           <View style={styles.vehicleRow}>
//             <Text style={styles.vehicleLabel}>Make:</Text>
//             <Text style={styles.vehicleValue}>
//               {data.make}
//             </Text>
//           </View>

//           <View style={styles.vehicleRow}>
//             <Text style={styles.vehicleLabel}>Model:</Text>
//             <Text style={styles.vehicleValue}>
//               {data.model}
//             </Text>
//           </View>

//           <View style={styles.vehicleRow}>
//             <Text style={styles.vehicleLabel}>Year:</Text>
//             <Text style={styles.vehicleValue}>
//               {data.year}
//             </Text>
//           </View>

//           <View style={styles.vehicleRow}>
//             <Text style={styles.vehicleLabel}>VIN:</Text>
//             <Text style={styles.vehicleValue}>
//               {data.vin}
//             </Text>
//           </View>

//           <View style={styles.vehicleRow}>
//             <Text style={styles.vehicleLabel}>Mileage:</Text>
//             <Text style={styles.vehicleValue}>
//               {data.mileage}
//             </Text>
//           </View>

//         </View>

//         {/* ==============================
//             PAYMENT TERMS
//         ============================== */}
//         <Text style={styles.sectionTitle}>
//           Purchase Price and Payment Terms
//         </Text>

//         <Text style={styles.paragraph}>
//           The total purchase price for the vehicle is $
//           {data.total_price} (Twelve Thousand Dollars),
//           to be paid by the Buyer to the Seller as follows:
//         </Text>

//         <Text style={styles.paragraph}>
//           Down Payment: ${data.down_payment} due upon
//           signing of this Agreement. Second Payment: ${data.second_payment} due
//           two (2) weeks from the date of signing.
//         </Text>

//         <Text style={styles.paragraph}>

//         </Text>

//         <Text style={styles.paragraph}>
//           Remaining Balance: ${data.remaining_balance}
//           to be paid in four (4) equal monthly
//           installments of $1,000 each, starting one
//           month from the date of the second payment.
//         </Text>

//         {/* ==============================
//             LATE PAYMENT
//         ============================== */}
//         <Text style={styles.sectionTitle}>
//           Late Payment / Default
//         </Text>

//         <Text style={styles.paragraph}>
//           If the Buyer fails to make any scheduled
//           payment on time, the Buyer agrees to pay
//           interest at a rate of $200 per month on
//           the overdue amount until paid in full.
//         </Text>

//         <Text style={styles.paragraph}>
//           If the Buyer fails to pay any installment
//           for more than thirty (30) days, the Seller
//           reserves the right to repossess the vehicle
//           and retain all prior payments made as
//           liquidated damages.
//         </Text>

//         {/* ==============================
//             OWNERSHIP
//         ============================== */}
//         <Text style={styles.sectionTitle}>
//           Transfer of Ownership
//         </Text>

//         <Text style={styles.paragraph}>
//           The Seller agrees to transfer ownership of
//           the vehicle to the Buyer upon receipt of
//           the full purchase price.
//         </Text>

//         <Text style={styles.paragraph}>
//           Until full payment is made, the vehicle
//           shall remain the property of the Seller,
//           and the Buyer shall take possession as
//           a bailee.
//         </Text>

//         {/* ==============================
//             CONDITION
//         ============================== */}
//         <Text style={styles.sectionTitle}>
//           Condition of Vehicle
//         </Text>

//         <Text style={styles.paragraph}>
//           The Buyer acknowledges that they have
//           inspected the vehicle and accepts it in
//           its current condition. The Seller makes
//           no warranties, express or implied, except
//           as may be stated in writing.
//         </Text>

//         {/* ==============================
//             GOVERNING LAW
//         ============================== */}
//         <Text style={styles.sectionTitle}>
//           Governing Law
//         </Text>

//         <Text style={styles.paragraph}>
//           This Agreement shall be governed by and
//           construed in accordance with the laws
//           of the state of{" "}
//           {data.state_law || "__________"}.
//         </Text>

//         {/* ==============================
//             ENTIRE AGREEMENT
//         ============================== */}
//         <Text style={styles.sectionTitle}>
//           Entire Agreement
//         </Text>

//         <Text style={styles.paragraph}>
//           This Agreement constitutes the entire
//           understanding between the parties and
//           supersedes all prior agreements or
//           understandings, whether written or oral.
//         </Text>

//         {/* ==============================
//             SIGNATURES
//         ============================== */}
//         <View style={styles.signatureSection}>

//           <Text style={styles.sectionTitle}>
//             Signatures
//           </Text>

//           <View style={styles.signatureRow}>

//             {/* SELLER */}
//             <View style={styles.signatureCol}>
//               <Text style={styles.signatureLine}>
//                 {data.seller_name || "Seller Name"}
//               </Text>

//               <Text style={styles.signLabel}>
//                 Seller Signature
//               </Text>
//             </View>

//             {/* BUYER */}
//             <View style={styles.signatureCol}>
//               <Text style={styles.signatureLine}>
//                 {data.buyer_name || "Buyer Name"}
//               </Text>

//               <Text style={styles.signLabel}>
//                 Buyer Signature
//               </Text>
//             </View>

//           </View>

//           <Text style={styles.dateText}>
//             Date: {agreementDate}
//           </Text>

//         </View>

//         {/* ==============================
//             FOOTER
//         ============================== */}
//         <View style={styles.footer} fixed>
//           <Text>
//             ZuluWhiskey Legal Contracts System
//           </Text>

//           <Text>
//             Confidential Legal Document
//           </Text>
//         </View>

//       </Page>
//     </Document>
//   );
// };

// export default CarPurchaseAgreementPdf;